<template>
  <main class="main main--risk risk pab2">
    <div class="group">
      <div class="risk__wrapper">
        <h1 
          :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
          class="h1">Help is available</h1>

        <h2 
          :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
          class="h2">Call <a :href="`tel:${number}`" class="tdn">{{ number }}</a> if you’d like to speak with someone.</h2>
        <p class="p">Violence and thoughts of self-harm are serious matters that can be common during difficult moments. Our {{ org.program_name }} care team has certified counselors, available 24/7, that are ready to listen and direct you to the right help.</p>

        <h2 
          :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
          class="h2">If you are in crisis, call 911 now.</h2>
        <p class="p">If you are having an emergency right now, please call 911.</p>

        <module-button
          button="secondary"
          link="help-myself"
          label="Go back"
        />
      </div>
    </div>
  </main>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'risk',

  computed: {
    ...mapGetters('app', [
      'org',
    ]),

    number() {
      return this.org.phone;
    },
  },
};
</script>



// WEBPACK FOOTER //
// Risk.vue?76a6687a